import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const downloadElementAsPDF = async (element, options = {}) => {
  if (!element) {
    console.error('No element provided for PDF export.');
    return;
  }

  const {
    filename = 'dashboard.pdf',
    hideScrollbars = true,
    pdfOrientation = 'landscape'
  } = options;

  const originalOverflow = element.style.overflow;
  if (hideScrollbars) element.style.overflow = 'hidden';

  element.classList.add('pdf-export');

  try {
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      width: element.scrollWidth,
      height: element.scrollHeight,
      backgroundColor: null,
      scrollY: -window.scrollY,
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF(pdfOrientation === 'landscape' ? 'l' : 'p', 'mm', 'a4');
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(filename);
  } catch (err) {
    console.error('PDF export failed:', err);
  } finally {
    element.classList.remove('pdf-export');
    if (hideScrollbars) element.style.overflow = originalOverflow;
  }
};